import {
    apiCallFailure,
    apiCallRequest,
    apiCallSuccess,
} from "../Action/Action";
import { call, put, takeLatest, fork, all } from "redux-saga/effects";
import * as types from "../Action/actionTypes";
import * as NegotiationActionsAPI from "../../services/NegotiationActionsAPI"
import { CLEAR_API_CALL_MESSAGE, GET_AI_SUGGESTION_FOR_ACTION_CARDS, GET_AI_SUGGESTION_FOR_ACTION_CARDS_FAILURE, GET_AI_SUGGESTION_FOR_ACTION_CARDS_SUCCESS } from "../Action/actionTypes";


function* fetchNegotiationActions(): Generator {
    try {
        // API call or business logic here
        const response: any = yield call(NegotiationActionsAPI.fetchNegotiationActions)
        if (response.statusCode === 200) {
            yield put({ type: types.GET_NEGOTIATION_ACTIONS_SUCCESS, payload: response.result });
        } else {
            yield put({ type: types.GET_NEGOTIATION_ACTIONS_FAILURE, payload: "" });
        }
    } catch (e) {
        yield put({ type: types.GET_NEGOTIATION_ACTIONS_FAILURE, payload: e });
    }
}
function* negotiationActionRelation(): Generator {
    try {
        // API call or business logic here
        const response: any = yield call(NegotiationActionsAPI.negotiationActionRelation)
        if (response.statusCode === 200) {
            yield put({ type: types.GET_NEGOTIATION_ACTION_RELATION_SUCCESS, payload: response.result });
        } else {
            yield put({ type: types.GET_NEGOTIATION_ACTION_RELATION_FAILURE, payload: "" });
        }
    } catch (e) {
        yield put({ type: types.GET_NEGOTIATION_ACTION_RELATION_FAILURE, payload: e });
    }
}

function* addNegoAction(data:any):Generator{
   try {
        // API call or business logic here
    
        const response: any = yield call(NegotiationActionsAPI.addNegoAction,data)
        
        if (response.status === 200) {
             yield put(apiCallSuccess("New action created successfully"));
            yield put({ type: types.ADD_NEGOTIATION_ACTION_SUCCESS, payload: response.result });
             if(data.meta?.onSuccess){
                data.meta.onSuccess()
            }
        } else {
             yield put(
                apiCallFailure(
                    "An error occurred while creating a new action. Please try again."
                )
            );
           
            yield put({ type: types.ADD_NEGOTIATION_ACTION_FAILURE, payload: "" });
             if(data.meta?.onFailure){
                data.meta.onFailure()
            }
        }
    } catch (e) {
         yield put(
                apiCallFailure(
                    "An error occurred while creating a new action. Please try again."
                )
            );
        yield put({ type: types.ADD_NEGOTIATION_ACTION_FAILURE, payload: e });
         if(data.meta?.onFailure){
                data.meta.onFailure()
            }
    }
}
function* deleteNegoAction(data:any):Generator{
   try {
        // API call or business logic here
        
        const response: any = yield call(NegotiationActionsAPI.deleteNegoAction,data)
  
        if (response.status === 200) {
            yield put(apiCallSuccess("New action deleted successfully"));
            yield put({ type: types.DELETE_NEGOTIATION_ACTION_SUCCESS, payload: response.result });
            yield put({ type: types.GET_NEGOTIATION_ACTIONS });
        } else {
            yield put(
                apiCallFailure(
                    "An error occurred while deleting a new action. Please try again."
                )
            );
            yield put({ type: types.DELETE_NEGOTIATION_ACTION_FAILURE, payload: "" });
        }
    } catch (e) {
         yield put(
                apiCallFailure(
                    "An error occurred while deleting a new action. Please try again."
                )
            );
        yield put({ type: types.DELETE_NEGOTIATION_ACTION_FAILURE, payload: e });
    }
}
function* getAISuggestionForActionCards(action: any): Generator {
    try {
        yield put(apiCallRequest());
        const payload = action.payload;
        const response: any = yield call(NegotiationActionsAPI.getAISuggestionForActionCardsAPI, payload)
        if (response.status == 200) {
            yield put({ type:GET_AI_SUGGESTION_FOR_ACTION_CARDS_SUCCESS, payload: response.data })
            yield put({type:CLEAR_API_CALL_MESSAGE})
        } else {
            yield put({ type:GET_AI_SUGGESTION_FOR_ACTION_CARDS_FAILURE, payload: "" })
            yield put(apiCallFailure("Failed to fetch AI recommendations.Please try again."))
        }
    } catch (e) {
        yield put({ type: GET_AI_SUGGESTION_FOR_ACTION_CARDS, payload: e })
        yield put(apiCallFailure("An error occurred while fetching AI recommendations. Please try again."))
    }
}
function* watchGetNegotiationActions(): Generator {
    yield takeLatest(types.GET_NEGOTIATION_ACTIONS, fetchNegotiationActions)
}
function* watchnegotiationActionRelation():Generator{
     yield takeLatest(types.GET_NEGOTIATION_ACTION_RELATION, negotiationActionRelation)
}
function* watchAddNegotiationAction(): Generator {
    yield takeLatest(types.ADD_NEGOTIATION_ACTION,addNegoAction)
}
function* watchDeleteNegotiationAction():Generator{
    yield takeLatest(types.DELETE_NEGOTIATION_ACTION,deleteNegoAction)
}
function* watchgetAISuggestionForActionCards():Generator{
    yield takeLatest(types.GET_AI_SUGGESTION_FOR_ACTION_CARDS,getAISuggestionForActionCards)
}
export default function* NegotiationActionsSaga(): Generator {
    yield all([
        fork(watchGetNegotiationActions),
        fork(watchAddNegotiationAction),
        fork(watchDeleteNegotiationAction),
        fork(watchgetAISuggestionForActionCards),
        fork(watchnegotiationActionRelation)
    ]);
}